module.exports = __webpack_public_path__ + "static/media/archive.77403e27.svg";